import { useState } from "react";
import { referansData, ReferansKayit } from "@/mocks/takip";

const FILTER_TABS = [
  { key: "tumu", label: "Tümü" },
  { key: "vermedi", label: "Referans Vermeyenler" },
  { key: "verdi", label: "Referans Verenler" },
  { key: "bekliyor", label: "Bekleyenler" },
  { key: "mesajYok", label: "30+ Gün Mesaj Yok" },
  { key: "yeniIstenmeyen", label: "Yeni – İstenmemiş" },
];

const DURUM_BADGE: Record<string, string> = {
  "Verdi": "bg-emerald-100 text-emerald-700",
  "Vermedi": "bg-red-100 text-red-600",
  "Bekliyor": "bg-amber-100 text-amber-700",
};
const DURUM_ICON: Record<string, string> = {
  "Verdi": "ri-checkbox-circle-line",
  "Vermedi": "ri-close-circle-line",
  "Bekliyor": "ri-time-line",
};

interface NotModalProps {
  kayit: ReferansKayit;
  onClose: () => void;
}
function NotModal({ kayit, onClose }: NotModalProps) {
  const [not, setNot] = useState(kayit.not);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-md shadow-2xl">
        <div className="bg-[#0B1120] px-6 py-4 rounded-t-2xl flex items-center justify-between">
          <h3 className="text-white font-bold text-sm">Not Ekle – {kayit.veliAdi}</h3>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-white/10 text-gray-400 cursor-pointer">
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="p-5 space-y-4">
          <textarea
            value={not}
            onChange={e => setNot(e.target.value)}
            rows={4}
            placeholder="Not yazın..."
            className="w-full text-sm px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366] resize-none"
          />
          <div className="flex gap-3">
            <button onClick={onClose} className="flex-1 py-2.5 text-sm border border-gray-200 text-gray-600 rounded-xl hover:bg-gray-50 cursor-pointer">İptal</button>
            <button onClick={onClose} className="flex-1 py-2.5 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer font-semibold">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  );
}

interface DurumModalProps {
  kayit: ReferansKayit;
  onClose: () => void;
}
function DurumModal({ kayit, onClose }: DurumModalProps) {
  const [durum, setDurum] = useState(kayit.referansDurumu);
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl w-full max-w-sm shadow-2xl">
        <div className="bg-[#0B1120] px-6 py-4 rounded-t-2xl flex items-center justify-between">
          <h3 className="text-white font-bold text-sm">Referans Durumunu Güncelle</h3>
          <button onClick={onClose} className="w-7 h-7 flex items-center justify-center rounded-lg hover:bg-white/10 text-gray-400 cursor-pointer">
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-gray-600 font-medium">{kayit.veliAdi} – {kayit.ogrenciAdi}</p>
          {["Verdi", "Vermedi", "Bekliyor"].map(d => (
            <button
              key={d}
              onClick={() => setDurum(d as ReferansKayit["referansDurumu"])}
              className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl border-2 text-sm font-medium cursor-pointer transition-all
                ${durum === d ? "border-[#25D366] bg-[#25D366]/5" : "border-gray-200 hover:bg-gray-50"}`}
            >
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${durum === d ? "border-[#25D366] bg-[#25D366]" : "border-gray-300"}`}>
                {durum === d && <i className="ri-check-line text-white text-xs"></i>}
              </div>
              {d}
            </button>
          ))}
          <button onClick={onClose} className="w-full py-2.5 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer font-semibold mt-2">Güncelle</button>
        </div>
      </div>
    </div>
  );
}

export default function ReferansPage() {
  const [activeFilter, setActiveFilter] = useState("tumu");
  const [search, setSearch] = useState("");
  const [notModal, setNotModal] = useState<ReferansKayit | null>(null);
  const [durumModal, setDurumModal] = useState<ReferansKayit | null>(null);

  const filtered = referansData.filter(r => {
    const s = search.toLowerCase();
    const matchSearch = !s || r.veliAdi.toLowerCase().includes(s) || r.ogrenciAdi.toLowerCase().includes(s) || r.telefon.includes(s);
    let matchFilter = true;
    if (activeFilter === "vermedi") matchFilter = r.referansDurumu === "Vermedi";
    else if (activeFilter === "verdi") matchFilter = r.referansDurumu === "Verdi";
    else if (activeFilter === "bekliyor") matchFilter = r.referansDurumu === "Bekliyor";
    else if (activeFilter === "mesajYok") matchFilter = r.sonMesaj === "-" || r.sonMesaj < "2026-04-19";
    else if (activeFilter === "yeniIstenmeyen") matchFilter = r.sonMesaj === "-";
    return matchSearch && matchFilter;
  });

  const verenCount = referansData.filter(r => r.referansDurumu === "Verdi").length;
  const vermeyenCount = referansData.filter(r => r.referansDurumu === "Vermedi").length;
  const buAyIstenen = referansData.filter(r => r.sonMesaj >= "2026-05-01").length;
  const yeniAdaylar = referansData.filter(r => r.sonMesaj === "-").length;

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Referans Takibi</h2>
          <p className="text-sm text-gray-500 mt-0.5">Velilerin referans durumunu yönetin ve mesaj gönderin</p>
        </div>
        <button className="px-5 py-2.5 text-sm bg-[#25D366] text-white rounded-xl hover:bg-[#20bd5a] cursor-pointer whitespace-nowrap flex items-center gap-2 font-semibold transition-colors">
          <div className="w-4 h-4 flex items-center justify-center"><i className="ri-whatsapp-line text-base"></i></div>
          Toplu Referans Mesajı Gönder
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[
          { label: "Toplam Veli", value: referansData.length, icon: "ri-group-line", color: "bg-[#0B1120] text-white" },
          { label: "Referans Veren", value: verenCount, icon: "ri-user-shared-line", color: "bg-emerald-500 text-white" },
          { label: "Referans Vermeyen", value: vermeyenCount, icon: "ri-user-unfollow-line", color: "bg-red-500 text-white" },
          { label: "Bu Ay İstenen", value: buAyIstenen, icon: "ri-calendar-check-line", color: "bg-amber-500 text-white" },
          { label: "Yeni Referans Adayı", value: yeniAdaylar, icon: "ri-user-add-line", color: "bg-violet-500 text-white" },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 p-4 flex items-center gap-3">
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${s.color}`}>
              <i className={`${s.icon} text-base`}></i>
            </div>
            <div>
              <p className="text-2xl font-bold text-gray-900">{s.value}</p>
              <p className="text-[11px] text-gray-500 leading-tight">{s.label}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Filters + Search */}
      <div className="bg-white rounded-2xl border border-gray-100">
        <div className="p-4 border-b border-gray-100 flex flex-col lg:flex-row gap-3">
          {/* Filter tabs */}
          <div className="flex flex-wrap gap-2 flex-1">
            {FILTER_TABS.map(t => (
              <button
                key={t.key}
                onClick={() => setActiveFilter(t.key)}
                className={`px-3 py-1.5 rounded-lg text-xs font-semibold cursor-pointer whitespace-nowrap transition-colors
                  ${activeFilter === t.key ? "bg-[#0B1120] text-white" : "bg-gray-100 text-gray-600 hover:bg-gray-200"}`}
              >
                {t.label}
              </button>
            ))}
          </div>
          {/* Search */}
          <div className="relative w-full lg:w-64">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center text-gray-400">
              <i className="ri-search-line text-sm"></i>
            </div>
            <input
              type="text"
              placeholder="İsim veya telefon ara..."
              value={search}
              onChange={e => setSearch(e.target.value)}
              className="w-full pl-9 pr-4 py-2 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
            />
          </div>
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-100">
                {["Veli Adı", "Öğrenci Adı", "Telefon", "Referans Durumu", "Verdiği Referans", "Son Mesaj", "Not", "İşlem"].map(h => (
                  <th key={h} className="text-left text-[11px] font-semibold text-gray-400 px-4 py-3 whitespace-nowrap">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(r => (
                <tr key={r.id} className="border-b border-gray-50 hover:bg-gray-50/50 transition-colors group">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2.5">
                      <div className="w-8 h-8 rounded-full bg-violet-100 flex items-center justify-center text-violet-700 text-xs font-bold flex-shrink-0">
                        {r.veliAdi.charAt(0)}
                      </div>
                      <span className="text-sm font-semibold text-gray-800 whitespace-nowrap">{r.veliAdi}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap">{r.ogrenciAdi}</td>
                  <td className="px-4 py-3 text-sm text-gray-600 whitespace-nowrap font-mono">{r.telefon}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold ${DURUM_BADGE[r.referansDurumu]}`}>
                      <i className={`${DURUM_ICON[r.referansDurumu]} text-xs`}></i>
                      {r.referansDurumu}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1.5">
                      {Array.from({ length: Math.min(r.verdigi, 5) }).map((_, i) => (
                        <div key={i} className="w-5 h-5 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600">
                          <i className="ri-user-line text-[9px]"></i>
                        </div>
                      ))}
                      {r.verdigi === 0 && <span className="text-xs text-gray-400">–</span>}
                      {r.verdigi > 0 && <span className="text-xs text-gray-500 ml-1">{r.verdigi} kişi</span>}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-xs text-gray-500 whitespace-nowrap">{r.sonMesaj === "-" ? <span className="text-gray-300">Henüz gönderilmedi</span> : r.sonMesaj}</td>
                  <td className="px-4 py-3 text-xs text-gray-500 max-w-[150px] truncate">{r.not || <span className="text-gray-300">—</span>}</td>
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <button
                        onClick={() => {}}
                        title="Referans Mesajı Gönder"
                        className="w-7 h-7 flex items-center justify-center rounded-lg bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 cursor-pointer transition-colors"
                      >
                        <i className="ri-whatsapp-line text-xs"></i>
                      </button>
                      <button
                        onClick={() => setDurumModal(r)}
                        title="Durumu Güncelle"
                        className="w-7 h-7 flex items-center justify-center rounded-lg bg-amber-50 text-amber-600 hover:bg-amber-100 cursor-pointer transition-colors"
                      >
                        <i className="ri-refresh-line text-xs"></i>
                      </button>
                      <button
                        onClick={() => setNotModal(r)}
                        title="Not Ekle"
                        className="w-7 h-7 flex items-center justify-center rounded-lg bg-gray-100 text-gray-500 hover:bg-gray-200 cursor-pointer transition-colors"
                      >
                        <i className="ri-sticky-note-line text-xs"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="py-16 text-center">
              <div className="w-12 h-12 mx-auto rounded-full bg-gray-100 flex items-center justify-center mb-3">
                <i className="ri-search-line text-gray-400 text-xl"></i>
              </div>
              <p className="text-sm text-gray-400">Kayıt bulunamadı</p>
            </div>
          )}
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden divide-y divide-gray-100">
          {filtered.map(r => (
            <div key={r.id} className="p-4 space-y-3">
              <div className="flex items-start justify-between gap-2">
                <div className="flex items-center gap-2.5">
                  <div className="w-9 h-9 rounded-full bg-violet-100 flex items-center justify-center text-violet-700 text-sm font-bold flex-shrink-0">
                    {r.veliAdi.charAt(0)}
                  </div>
                  <div>
                    <p className="text-sm font-bold text-gray-900">{r.veliAdi}</p>
                    <p className="text-xs text-gray-500">{r.ogrenciAdi}</p>
                  </div>
                </div>
                <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold ${DURUM_BADGE[r.referansDurumu]}`}>
                  {r.referansDurumu}
                </span>
              </div>
              <div className="flex items-center justify-between text-xs text-gray-500">
                <span className="font-mono">{r.telefon}</span>
                <span>{r.verdigi > 0 ? `${r.verdigi} referans` : "Referans yok"}</span>
              </div>
              <div className="flex gap-2 pt-1">
                <button className="flex-1 py-2 text-xs font-semibold bg-[#25D366]/10 text-[#25D366] rounded-xl cursor-pointer flex items-center justify-center gap-1">
                  <i className="ri-whatsapp-line"></i> Mesaj Gönder
                </button>
                <button onClick={() => setDurumModal(r)} className="flex-1 py-2 text-xs font-semibold bg-amber-50 text-amber-600 rounded-xl cursor-pointer flex items-center justify-center gap-1">
                  <i className="ri-refresh-line"></i> Durumu Güncelle
                </button>
                <button onClick={() => setNotModal(r)} className="px-3 py-2 text-xs bg-gray-100 text-gray-500 rounded-xl cursor-pointer flex items-center justify-center">
                  <i className="ri-sticky-note-line"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="px-4 py-3 border-t border-gray-100 flex items-center justify-between">
          <p className="text-xs text-gray-400">{filtered.length} kayıt gösteriliyor</p>
        </div>
      </div>

      {notModal && <NotModal kayit={notModal} onClose={() => setNotModal(null)} />}
      {durumModal && <DurumModal kayit={durumModal} onClose={() => setDurumModal(null)} />}
    </div>
  );
}